export function filterArray<T = any>(
  items: T[],
  predicate: (item: T) => boolean
): T[] {
  return items.filter(predicate);
}